import React, { forwardRef, useMemo } from 'react'
import Select from 'react-select/creatable'
import { components } from 'react-select'

const NullRenderer = () => null

const Input = (props) => {
  const { placeholder } = props.selectProps
  return <components.Input {...props} placeholder={placeholder} />
}

Input.displayName = 'Input'

const createTag = (value) => {
  return {
    value,
    label: value
  }
}

const decodeTag = (tag) => tag.value

const createSelectValue = (tags = []) => {
  return tags.map(createTag)
}

const Tags = forwardRef((props, ref) => {
  const { tags, onChange, disabled, placeholder } = props

  const value = useMemo(() => createSelectValue(tags), [tags])

  const handleChange = (inputValue) => {
    const updatedTags = inputValue.map(decodeTag)
    onChange(updatedTags)
  }

  return (
    <Select
      ref={ref}
      isMulti
      isClearable={false}
      placeholder={placeholder}
      isDisabled={disabled}
      classNamePrefix='TagsInput'
      components={{
        DropdownIndicator: NullRenderer,
        IndicatorSeparator: NullRenderer,
        Menu: NullRenderer,
        MultiValueRemove: NullRenderer,
        Input
      }}
      styles={{
        multiValue: (base) => ({
          ...base,
          backgroundColor: 'transparent'
        }),
        multiValueLabel: (base) => ({
          ...base,
          backgroundColor: '#ccc',
          padding: '5px 15px',
          paddingLeft: '15px',
          borderRadius: '20px',
          fontSize: 'inherit'
        }),
        control: (base) => ({
          ...base,
          border: 'none',
          boxShadow: 'none',
          backgroundColor: 'transparent'
        }),
        input: (base) => ({
          ...base,
          display: 'flex'
        })
      }}
      value={value}
      onChange={handleChange}
    />
  )
})

Tags.displayName = 'Tags'

export default Tags
